import React, { Component } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  Divider,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction
} from "@material-ui/core";
import {
  ImageSearch,
  Delete,
  RemoveCircle,
  CheckCircle,
  Edit,
  InfoOutlined,
  Group,
  Settings,
  HighlightOffTwoTone
} from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import myStyles from "./Style";
import { FirebaseContext } from "../../FirebaseInit";
import EXIF from "exif-js";

const INIT_STATE = {
  img: null,
  loading: false,
  allowEdit: false,
  deleteDialog: false,
  exitDialog: false,
  tabIndex: 0
};

class GroupDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INIT_STATE,
      groupName: props.dialogInfo.name,
      dialogInfo: props.dialogInfo
    };
    this.handleUpload = this.handleUpload.bind(this);
    this.upload = this.upload.bind(this);
    this.deleteImg = this.deleteImg.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.allowEdit = this.allowEdit.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.canvasRef = React.createRef();
    this.imgRef = React.createRef();
  }

  removeMember(firebase, key) {
    let membersInfo = this.state.dialogInfo.membersInfo;

    let email = membersInfo[key].email;
    membersInfo[key].left = true;
    let dialogInfo = this.state.dialogInfo;
    dialogInfo[membersInfo] = membersInfo;

    firebase
      .fs()
      .collection("groups")
      .doc(this.props.group.id)
      .update({
        members: firebase.fs.FieldValue.arrayRemove(email)
      })
      .then(this.setState({ dialogInfo }));
  }

  toggleDialog(e) {
    if (e.currentTarget.name === "delete")
      this.setState({ deleteDialog: true });
    else if (e.currentTarget.name === "exit")
      this.setState({ exitDialog: true });
    else this.setState({ deleteDialog: false, exitDialog: false });
  }

  confirmDialog(firebase, e) {
    let name = e.currentTarget.name;
    if (name === "confirmDelete") {
      firebase
        .fs()
        .collection("groups")
        .doc(this.props.dialogInfo.id)
        .set(
          {
            // activeMembers: firebase.fs.FieldValue.arrayRemove(
            //   this.props.user.email
            // ),
            membersInfo: {
              [this.props.user.uid]: { joined: firebase.fs.Timestamp.now() }
            },
            unread: { [this.props.user.uid]: { count: 0, status: "Out" } },
            deleted: firebase.fs.FieldValue.arrayUnion(this.props.user.uid)
          },
          { merge: true }
        )
        .then(() => {
          this.setState({ deleteDialog: false });
          this.props.chatDeleted();
          this.props.toggleAlert("Chat deleted.", "success");
        })
        .catch(err => {
          console.log(err);
          this.setState({ deleteDialog: false });
          this.props.toggleAlert(
            "Error deleting chat.Please try again",
            "error"
          );
        });
    } else {
      let membersInfo = this.props.dialogInfo.membersInfo;
      delete membersInfo[this.props.user.uid];
      firebase
        .fs()
        .collection("groups")
        .doc(this.props.dialogInfo.id)
        .update({
          members: firebase.fs.FieldValue.arrayRemove(this.props.user.email),
          membersInfo: membersInfo
        })
        .then(() => {
          this.setState({ exitDialog: false });
          this.props.chatDeleted();
          this.props.toggleAlert("Chat deleted.", "success");
        })
        .catch(err => {
          console.log(err);
          this.setState({ exitDialog: false });
          this.props.toggleAlert(
            "Error deleting chat.Please try again",
            "error"
          );
        });
    }
  }

  upload(image, firebase, group) {
    this.setState({ loading: true, img: image });
    this.props.toggleLoading();
    const storageRef = firebase.strg().ref();
    const imgref = storageRef.child(`GPIC/${group.id}`);
    const ut = imgref.put(image.file);
    // ut.on(
    //   "state_changed",
    //   snapshot => {
    //     var progress =
    //       (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //     console.log("Upload is " + progress + "% done");
    //     // eslint-disable-next-line default-case
    //     switch (snapshot.state) {
    //       case firebase.strg.TaskState.PAUSED:
    //         console.log("Upload is paused");
    //         break;
    //       case firebase.strg.TaskState.RUNNING:
    //         console.log("Upload is running");
    //         break;

    //       case firebase.strg.TaskState.ERROR:
    //         console.log("Upload Error");
    //         break;
    //     }
    //   },
    //   error => {
    //     this.props.toggleAlert(error.message, "error");
    //   }
    // );
    ut.then(snap => {
      snap.ref
        .getDownloadURL()
        .then(url => {
          firebase
            .fs()
            .collection("groups")
            .doc(group.id)
            .update({ ppURL: url });

          group.ppURL = url;
          this.setState({
            loading: false,
            allowEdit: false,
            group: group
          });

          this.props.toggleLoading();
        })

        .catch(error => {
          this.setState({
            loading: false,
            allowEdit: false
          });
          this.props.toggleLoading();
        });
    }).catch(error => {
      this.setState({
        loading: false,
        allowEdit: false
      });
      this.props.toggleLoading();
      this.props.toggleAlert(
        "Connection timeout. Please check your internet connection and try again later.",
        "error"
      );
    });
  }

  handleUpload(firebase, group, e) {
    if (e.target.value) {
      let image = {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0])
      };

      if (image) {
        let img = this.imgRef.current;
        let canvas = this.canvasRef.current;
        let context = canvas.getContext("2d");
        let orientation = null;
        const upload = this.upload;
        EXIF.getData(e.target.files[0], function() {
          let orientationTag = EXIF.getTag(this, "Orientation");

          orientation = orientationTag ? orientationTag : 1;

          img.addEventListener("load", () => {
            let width = img.width;
            let height = img.height;
            if ([5, 6, 7, 8].indexOf(orientation) > -1) {
              canvas.width = height;
              canvas.height = width;
            } else {
              canvas.width = width;
              canvas.height = height;
            }
            switch (orientation) {
              case 1:
                context.transform(1, 0, 0, 1, 0, 0);
                break;
              case 2:
                context.transform(-1, 0, 0, 1, width, 0);
                break;
              case 3:
                context.transform(-1, 0, 0, -1, width, height);
                break;
              case 4:
                context.transform(1, 0, 0, -1, 0, height);
                break;
              case 5:
                context.transform(0, 1, 1, 0, 0, 0);
                break;
              case 6:
                context.transform(0, 1, -1, 0, height, 0);
                break;
              case 7:
                context.transform(0, -1, -1, 0, height, width);
                break;
              case 8:
                context.transform(0, -1, 1, 0, 0, width);
                break;
              default:
                break;
            }

            context.drawImage(img, 0, 0, width, height);
            canvas.toBlob(blob => {
              let url = URL.createObjectURL(blob);
              image = {
                file: blob,
                url: url
              };
              upload(image, firebase, group);
            }, "image/jpeg");
          });
          img.src = image.url;
        });
      } else {
        this.props.toggleAlert("Error uploading the image", "error");
      }
    } else return;
  }

  deleteImg(firebase, group) {
    if (group.ppURL) {
      this.setState({ loading: true });
      this.props.toggleLoading();
      const storageRef = firebase.strg().ref();
      const imgref = storageRef.child(`GPIC/${group.id}`);
      imgref
        .delete()
        .then(() => {
          firebase
            .fs()
            .collection("groups")
            .doc(group.id)
            .update({ ppURL: null });
          group.ppURL = null;

          this.setState({
            loading: false,
            allowEdit: false,
            img: null,
            group: group
          });
          this.props.toggleLoading();
        })
        .catch(error => {
          this.setState({
            loading: false,
            allowEdit: false
          });
          this.props.toggleLoading();
          this.props.toggleAlert("Uh-oh, an error occurred!", "error");
        });
    } else if (this.state.img) {
      this.setState({ img: null });
    }
  }

  allowEdit(firebase, group, e) {
    if (e.currentTarget.getAttribute("name") === "close") {
      this.setState({
        allowEdit: false,
        groupName: group.name
      });
    } else if (
      e.currentTarget.getAttribute("name") === "edit" &&
      this.state.allowEdit === true
    ) {
      this.setState({ loading: true });
      this.props.toggleLoading();
      firebase
        .fs()
        .collection("groups")
        .doc(group.id)
        .update({ name: this.state.groupName })
        .then(() => {
          group.name = this.state.groupName;
          this.props.toggleAlert("Profile updated!", "success");
          this.setState({ loading: false, group });
          this.props.toggleLoading();
        })
        .catch(err => {
          this.setState({ loading: false });
          this.props.toggleLoading();
          this.props.toggleAlert("Uh-oh, an error occurred!", "error");
        });

      this.setState({ allowEdit: false });
    } else if (e.currentTarget.getAttribute("name") === "edit") {
      this.setState({ allowEdit: true });
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  changeTab(e, value) {
    this.setState({ tabIndex: value });
  }

  render() {
    const { classes } = this.props;
    const firebase = this.context;
    return (
      <Box width="100%" height="60vh" overflow="hidden" position='relative'>
        <Box
          position="absolute"
          top="0"
          left="0"
          height="0px"
          overflow="hidden"
        >
          <img alt="" ref={this.imgRef} className={classes.img} />
          <canvas ref={this.canvasRef} className={classes.canvas} />
        </Box>
        <Tabs
          variant="fullWidth"
          value={this.state.tabIndex}
          onChange={this.changeTab}
        >
          <Tab label="Settings" icon={<Settings />} />
          <Tab label="Members" icon={<Group />} />
        </Tabs>
        <Box
          boxSizing="border-box"
          mt={1}
          height="calc(60vh - 80px)"
          style={{ overflowY: "scroll" }}
        >
          <Box my={2} hidden={this.state.tabIndex !== 1}>
            <List>
              {Object.keys(this.props.dialogInfo.membersInfo).map(
                (memberKey, index) =>
                  memberKey === this.props.user.uid ? (
                    <ListItem divider button key={index}>
                      <ListItemAvatar>
                        <Avatar
                          src={
                            this.props.dialogInfo.membersInfo[memberKey].ppURL
                          }
                        >
                          <Group />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          this.props.dialogInfo.membersInfo[memberKey].username
                        }
                        secondary={
                          <Typography noWrap>
                            {this.props.dialogInfo.membersInfo[memberKey].email}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ) : (
                    this.props.dialogInfo.members.indexOf(
                      this.props.dialogInfo.membersInfo[memberKey].email
                    ) > -1 && (
                      <ListItem divider button key={index}>
                        <ListItemAvatar>
                          <Avatar
                            src={
                              this.state.dialogInfo.membersInfo[memberKey].ppURL
                            }
                          >
                            <Group />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            this.state.dialogInfo.membersInfo[memberKey]
                              .username
                          }
                          secondary={
                            <Typography noWrap>
                              {
                                this.state.dialogInfo.membersInfo[memberKey]
                                  .email
                              }
                            </Typography>
                          }
                        />
                        {this.state.dialogInfo.creator ===
                          this.props.user.email && (
                          <ListItemSecondaryAction>
                            <IconButton
                              onClick={this.removeMember.bind(
                                this,
                                firebase,
                                memberKey
                              )}
                            >
                              <HighlightOffTwoTone />
                            </IconButton>
                          </ListItemSecondaryAction>
                        )}
                      </ListItem>
                    )
                  )
              )}
            </List>
          </Box>
          <Box my={2} hidden={this.state.tabIndex !== 0}>
            <Typography variant="h6" color="primary">
              Profile picture
            </Typography>
            <Box
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Avatar
                src={
                  this.state.img
                    ? this.state.img.url
                    : this.props.dialogInfo.ppURL
                }
                className={classes.avatar}
              >
                <Group />
              </Avatar>

              <input
                accept="image/*"
                id="icon-button-file"
                type="file"
                className={classes.input}
                onChange={this.handleUpload.bind(
                  this,
                  firebase,
                  this.props.dialogInfo
                )}
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  component="span"
                  color="primary"
                  disabled={this.state.loading}
                >
                  <ImageSearch className={classes.iconBtn} fontSize="large" />
                </IconButton>
              </label>

              <IconButton
                onClick={this.deleteImg.bind(
                  this,
                  firebase,
                  this.props.dialogInfo
                )}
                disabled={
                  this.state.loading ||
                  (!this.props.dialogInfo.ppURL && !this.state.img)
                }
                color="secondary"
              >
                <Delete className={classes.iconBtn} fontSize="large" />
              </IconButton>
            </Box>
            <Divider />
            <Typography variant="h6" color="primary">
              Group name
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <TextField
                name="groupName"
                id="in"
                required
                fullWidth
                margin="normal"
                value={this.state.groupName}
                onChange={this.handleChange}
                disabled={this.state.loading || !this.state.allowEdit}
                variant="filled"
                className={classes.unameInput}
                autoFocus={true}
                size="small"
              />

              {this.state.allowEdit && (
                <>
                  <IconButton
                    name="close"
                    onClick={this.allowEdit.bind(null, null, this)}
                    disabled={this.state.loading}
                    color="secondary"
                  >
                    <RemoveCircle />
                  </IconButton>
                </>
              )}

              <label name="label" htmlFor="in">
                <IconButton
                  name="edit"
                  disabled={this.state.loading}
                  onClick={this.allowEdit.bind(
                    this,
                    firebase,
                    this.props.dialogInfo
                  )}
                  color="primary"
                  component="span"
                >
                  {this.state.allowEdit ? <CheckCircle /> : <Edit />}
                </IconButton>
              </label>
            </Box>
            <Divider />
            <Typography color="primary" variant="h6">
              Creator
            </Typography>
            <Typography paragraph color="textSecondary" variant="body1">
              {this.props.dialogInfo.creator}
            </Typography>
            <Divider />
            <Box
              mb={1}
              display="flex"
              justifyContent="center"
              flexDirection="column"
            >
              <Typography variant="h6" color="primary">
                Delete Group
              </Typography>
              <Box mb={2} display="flex" alignItems="center">
                <InfoOutlined
                  style={{ fontSize: 17, marginRight: "10px" }}
                  color="secondary"
                />
                <Typography color="secondary" variant="caption">
                  You will lose all the messages.
                </Typography>
              </Box>

              <Button
                disabled={this.state.loading}
                onClick={this.toggleDialog}
                color="secondary"
                variant="contained"
                name="delete"
                size="small"
                style={{ width: "max-content" }}
              >
                Delete Group
              </Button>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="center" flexDirection="column">
              <Typography variant="h6" color="primary">
                Exit group
              </Typography>
              <Box mb={2} display="flex" alignItems="center">
                <InfoOutlined
                  style={{ fontSize: 17, marginRight: "10px" }}
                  color="secondary"
                />
                <Typography color="secondary" variant="caption">
                  you will no longer be able to send messages to this group
                </Typography>
              </Box>

              <Button
                disabled={this.state.loading}
                onClick={this.toggleDialog}
                color="secondary"
                variant="contained"
                name="exit"
                size="small"
                style={{ width: "max-content" }}
              >
                Exit Group
              </Button>
            </Box>
          </Box>
          <Dialog
            open={this.state.deleteDialog || this.state.exitDialog}
            onClose={this.toggleDialog}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            style={{ zIndex: 1350 }}
          >
            <DialogTitle>
              {this.state.deleteDialog && "Delete Group"}
              {this.state.exitDialog && "Exit Group"}
            </DialogTitle>
            <DialogContent>
              <Typography>Are you sure?</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                disabled={this.state.loading}
                color="primary"
                onClick={this.toggleDialog}
                name="cancel"
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.loading}
                color="secondary"
                onClick={this.confirmDialog.bind(this, firebase)}
                name={this.state.deleteDialog ? "confirmDelete" : "confirmExit"}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    );
  }
}
GroupDialog.contextType = FirebaseContext;
export default withStyles(myStyles)(GroupDialog);
